import styled from "styled-components";
import { SIPWrapper } from "../SourceInProgress/SourceInProgress.styles";

export const CBDWrapper = styled(SIPWrapper)<{$useYellow : boolean}>`
    background: ${({ $useYellow, theme }) => !$useYellow ? theme.v3.colors.lightBlue : theme.v3.colors.lightYellow};
    border: 1px solid ${({ $useYellow, theme }) => $useYellow ? theme.v3.colors.midYellow : "rgba(127, 167, 246, 0.3)"};
`;